
import React from "react";
import {Route, Switch} from "react-router-dom";

import SignIn from "./SignIn";
import SignUp from "./SignUp"

const Commerce = ({match}) => (
  <Switch>  
    <Route path={`${match.url}/signin`} component={SignIn}/>
    <Route path={`${match.url}/signUp`} component={SignUp}/>
  </Switch>
);

export default Commerce; 